/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companyregistrationnumbervatnumber4Inputs */

const en_companyregistrationnumbervatnumber4 = /** @type {(inputs: Companyregistrationnumbervatnumber4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Registration Number / VAT Number`)
};

const de_companyregistrationnumbervatnumber4 = /** @type {(inputs: Companyregistrationnumbervatnumber4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handelsregisternummer / Umsatzsteuer-Identifikationsnummer`)
};

/**
* | output |
* | --- |
* | "Company Registration Number / VAT Number" |
*
* @param {Companyregistrationnumbervatnumber4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companyregistrationnumbervatnumber4 = /** @type {((inputs?: Companyregistrationnumbervatnumber4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companyregistrationnumbervatnumber4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companyregistrationnumbervatnumber4(inputs)
	return de_companyregistrationnumbervatnumber4(inputs)
});
export { companyregistrationnumbervatnumber4 as "companyRegistrationNumberVatNumber" }